import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';

export const ImmutableInstitution = ImmutablePropTypes.mapContains({
  id: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  hasCustomHelpPage: PropTypes.bool,
});
